import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadMadlibOptions } from '../../../../ng2/store/actions/madlib-options-actions';
import {
  getMadlibOptions,
  getMadlibOptionsLoadedStatus,
} from '../../../../ng2/store/selectors/madlib-options-selectors';

export const DIM1_MADLIB_PATHS =
  'studentDetails.classOf,' +
  'studentDetails.grade,' +
  'studentDetails.classOf,' +
  'studentDetails.officialClass,' +
  'pointPeople,' +
  'counselor,' +
  'gradPlanningDetails.plannedGraduationDate,' +
  'spedDetails.isSped,' +
  'ellDetails.isEll';
@Injectable()
export class MadLibOptionsResolver {
  resolveMadLibOptions$(currentSchool, store): Promise<Observable<any>> {
    const { _id } = currentSchool;
    const destroy$: Subject<boolean> = new Subject<boolean>();

    const payload = { paths: DIM1_MADLIB_PATHS, schoolId: _id };

    return new Promise(resolve => {
      store
        .select(getMadlibOptionsLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new LoadMadlibOptions(payload));
          if (loaded) {
            const madLibOptions$ = store.select(getMadlibOptions);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(madLibOptions$);
          }
        });
    });
  }
}
